import { Injectable, makeEnvironmentProviders, ɵSHARED_STYLES_HOST } from '@angular/core';
import { ɵSharedStylesHost } from '@angular/platform-browser';

@Injectable()
export class LayeredSharedStylesHost extends ɵSharedStylesHost {
  private static readonly prefixes = [
    'mat-',
    '.mat-',
    '.mdc-',
    '.cdk-',
    'div.mat-', // autocomplete
    '@keyframes _mat-', // snackbar
  ];

  protected override addUsage(...args: Parameters<ɵSharedStylesHost['addUsage']>) {
    args[0] = this.preprocessValue(args[0]);
    return super.addUsage(...args);
  }

  protected override removeUsage(...args: Parameters<ɵSharedStylesHost['removeUsage']>) {
    args[0] = this.preprocessValue(args[0]);
    return super.removeUsage(...args);
  }

  private preprocessValue(value: string) {
    for (const p of LayeredSharedStylesHost.prefixes) {
      if (value.startsWith(p))
        return `@layer base { ${value} }`;
    }
    return value;
  }
}

export function provideLayeredStyles() {
  return makeEnvironmentProviders([
    {
      provide: ɵSHARED_STYLES_HOST,
      useClass: LayeredSharedStylesHost
    }
  ]);
}